import { z } from 'zod';
import { query } from '../../utils';
export const listRecentWinners = query({
    method: 'GET',
    path: '/recent-winners',
    responses: {
        200: z.object({
            recentWinners: z.array(z.object({
                username: z.string().nullable(),
                userId: z.string(),
                valueInCents: z.number(),
                createdAt: z.string(),
                avatar: z.string().nullable(),
                type: z.string(),
            })),
        }),
    },
});
